import {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import { useDispatch } from "react-redux";

import {
  setSlugClient,
} from "../redux/slices/clientSlice";

import {
  getPublicClientBySlugApi,
} from "../api/ClientActions";

const ClientPublicPage: React.FC = () => {
  const { slug } = useParams<{
    slug: string;
  }>();

  const dispatch =
    useDispatch<any>();

  const navigate =
    useNavigate();

  const [
    loading,
    setLoading,
  ] = useState(true);

  useEffect(() => {
    const token =
      localStorage.getItem(
        "token"
      );

    let user: any = null;

    try {
      user = JSON.parse(
        localStorage.getItem(
          "user"
        ) || "null"
      );
    } catch {
      user = null;
    }

    // ==========================
    // LOGIN REQUIRED
    // ==========================
    if (
      !token ||
      !user?.user_id
    ) {
      navigate(
        "/login",
        {
          replace: true,
        }
      );

      return;
    }

    // ==========================
    // INVALID SLUG
    // ==========================
    if (
      !slug ||
      String(slug).trim() ===
        ""
    ) {
      navigate(
        "/notfound",
        {
          replace: true,
        }
      );

      return;
    }

    let isMounted = true;

    // ==========================
    // FETCH CLIENT
    // ==========================
    const fetchClient =
      async () => {
        try {
          if (
            isMounted
          ) {
            setLoading(
              true
            );
          }

          const result =
            await getPublicClientBySlugApi(
              slug
            );

          if (
            !isMounted
          ) {
            return;
          }

          if (
            result?.success ===
              false ||
            result?.status ===
              false
          ) {
            navigate(
              "/notfound",
              {
                replace:
                  true,
              }
            );

            return;
          }

          const client =
            result?.data;

          if (!client) {
            navigate(
              "/notfound",
              {
                replace:
                  true,
              }
            );

            return;
          }

          // ==========================
          // SAVE IN REDUX
          // ==========================
          dispatch(
            setSlugClient(
              client
            )
          );

          // ==========================
          // SAVE SELECTED CLIENT
          // ==========================
          localStorage.setItem(
            "selectedClient",
            JSON.stringify(
              client
            )
          );

          // ==========================
          // GO TO HOME
          // ==========================
          navigate(
            "/home",
            {
              replace: true,
            }
          );
        } catch (
          error
        ) {
          console.error(
            "Public client fetch error:",
            error
          );

          if (
            isMounted
          ) {
            navigate(
              "/notfound",
              {
                replace:
                  true,
              }
            );
          }
        } finally {
          if (
            isMounted
          ) {
            setLoading(
              false
            );
          }
        }
      };

    fetchClient();

    return () => {
      isMounted = false;
    };
  }, [
    slug,
    dispatch,
    navigate,
  ]);

  return (
    <div
      style={{
        minHeight:
          "100vh",
        display:
          "flex",
        alignItems:
          "center",
        justifyContent:
          "center",
        background:
          "#f8fafc",
      }}
    >
      {loading && (
        <div
          style={{
            display:
              "flex",
            flexDirection:
              "column",
            alignItems:
              "center",
            gap: "12px",
            color:
              "#64748b",
          }}
        >
          <div className="spinner-border text-primary" />

          <span
            style={{
              fontSize:
                "13px",
              fontWeight:
                600,
            }}
          >
            Loading club...
          </span>
        </div>
      )}
    </div>
  );
};

export default ClientPublicPage;